module.exports = __webpack_public_path__ + "img/55ne.0713d6c8.svg";